import React from "react";
import { observer } from "mobx-react";
import {
  Container,
  MasterContainer,
  LoaderWrapper,
  ErrorWrapper,
  EmptyWrapper,
} from "./Calls.styled";
import { Filters, Items, Paginator } from "./components";
import {
  CircularProgress,
  WidgetEmptyErrorPlaceholder,
} from "@ann/web-components";

const Calls = observer(
  ({
    items = [],
    meta,
    loading,
    error,
    onPageChange,
    onItemsPerPageChange,
    onRefresh,
  }) => {
    const hasItems = items.length > 0;

    return (
      <MasterContainer>
        <Container>
          <Filters />
          {loading ? (
            <LoaderWrapper>
              <CircularProgress size="medium" />
            </LoaderWrapper>
          ) : error ? (
            <ErrorWrapper>
              <WidgetEmptyErrorPlaceholder
                icon="error"
                title="Something went wrong"
                message="We couldn't load call activities. Please try again."
                buttonText="Retry"
                showButton={true}
                onClick={onRefresh}
              />
            </ErrorWrapper>
          ) : hasItems ? (
            <Items items={items} />
          ) : (
            <EmptyWrapper>
              <WidgetEmptyErrorPlaceholder
                icon="searchOff"
                title="No call activities"
                message="Will display the latest actions, messages, or service events."
                showButton={false}
              />
            </EmptyWrapper>
          )}
        </Container>
        {hasItems && (
          <Paginator
            meta={meta}
            loading={loading}
            onPageChange={onPageChange}
            onItemsPerPageChange={onItemsPerPageChange}
          />
        )}
      </MasterContainer>
    );
  }
);

export default Calls;
